/* ==========================================================================
   AeroForce — comportamiento propio
   Todo vanilla, sin librerias externas.
   ========================================================================== */

(function () {
  'use strict';

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* --- Video de fondo del hero -------------------------------------------- */
  // El atributo autoplay basta en la inmensa mayoria de navegadores porque el
  // video ya lleva muted+playsinline, pero en algunos casos el navegador lo
  // deja pausado hasta que un script pide reproducirlo. Si el navegador bloquea igualmente el autoplay, el poster
  // (la foto fija) ya se ve de fondo, asi que no hay hueco en blanco.

  function initVideoHero() {
    var v = document.querySelector('.af-hero__video');
    if (!v || reduce) return;
    var intento = v.play();
    if (intento && typeof intento.catch === 'function') intento.catch(function () {});
  }

  /* --- Animaciones de entrada ------------------------------------------ */

  function initReveals() {
    var els = document.querySelectorAll('.af-reveal');
    if (!els.length) return;

    if (reduce || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('af-visible'); });
      return;
    }

    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('af-visible');
        obs.unobserve(entry.target);
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -60px 0px' });

    var alto = window.innerHeight || document.documentElement.clientHeight;

    els.forEach(function (el) {
      if (el.classList.contains('af-visible')) return;
      // Lo que YA se ve al cargar (el hero, sobre todo) se muestra de inmediato:
      // asi no depende del observador y entra antes en pantalla.
      var r = el.getBoundingClientRect();
      if (r.top < alto && r.bottom > 0) {
        el.classList.add('af-visible');
        return;
      }
      obs.observe(el);
    });
  }

  /* --- Cifras animadas (count-up) -------------------------------------- */

  function formatea(valor, decimales, separador) {
    var txt = decimales > 0 ? valor.toFixed(decimales) : String(Math.round(valor));
    var partes = txt.split('.');
    partes[0] = partes[0].replace(/\B(?=(\d{3})+(?!\d))/g, separador);
    return partes.join(',');
  }

  function initCifras() {
    var els = document.querySelectorAll('[data-af-cifra]');
    if (!els.length) return;

    function pinta(el, valor) {
      var dec = parseInt(el.dataset.afDecimales || '0', 10);
      var sep = el.dataset.afSeparador === 'no' ? '' : '.';
      el.textContent = formatea(valor, dec, sep);
    }

    if (reduce || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { pinta(el, parseFloat(el.dataset.afCifra) || 0); });
      return;
    }

    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var el = entry.target;
        obs.unobserve(el);

        var destino = parseFloat(el.dataset.afCifra) || 0;
        var duracion = 1500;
        var inicio = null;

        function paso(t) {
          if (inicio === null) inicio = t;
          var p = Math.min((t - inicio) / duracion, 1);
          var eased = 1 - Math.pow(1 - p, 3);
          pinta(el, destino * eased);
          if (p < 1) requestAnimationFrame(paso);
          else pinta(el, destino);
        }
        requestAnimationFrame(paso);
      });
    }, { threshold: 0.5 });

    els.forEach(function (el) { pinta(el, 0); obs.observe(el); });
  }

  /* --- FAQ acordeon ----------------------------------------------------- */

  function initFaq() {
    var items = document.querySelectorAll('.af-faq__item');
    if (!items.length) return;

    items.forEach(function (item) {
      // Evita enganchar el mismo boton dos veces si af-scripts.js se ejecuta
      // mas de una vez sobre el mismo DOM (p. ej. el editor de temas).
      if (item.dataset.afFaqListo === '1') return;
      var btn = item.querySelector('.af-faq__pregunta');
      var res = item.querySelector('.af-faq__respuesta');
      if (!btn || !res) return;
      item.dataset.afFaqListo = '1';

      btn.addEventListener('click', function () {
        var abierto = item.classList.contains('af-abierto');

        // cierra los hermanos del mismo bloque
        var hermanos = item.parentElement
          ? item.parentElement.querySelectorAll('.af-faq__item')
          : [];
        hermanos.forEach(function (h) {
          if (h === item) return;
          h.classList.remove('af-abierto');
          var r = h.querySelector('.af-faq__respuesta');
          var b = h.querySelector('.af-faq__pregunta');
          if (r) r.style.maxHeight = null;
          if (b) b.setAttribute('aria-expanded', 'false');
        });

        if (abierto) {
          item.classList.remove('af-abierto');
          res.style.maxHeight = null;
          btn.setAttribute('aria-expanded', 'false');
        } else {
          item.classList.add('af-abierto');
          res.style.maxHeight = res.scrollHeight + 'px';
          btn.setAttribute('aria-expanded', 'true');
        }
      });
    });

    // recalcula alturas al redimensionar
    var t;
    window.addEventListener('resize', function () {
      clearTimeout(t);
      t = setTimeout(function () {
        document.querySelectorAll('.af-faq__item.af-abierto').forEach(function (item) {
          var res = item.querySelector('.af-faq__respuesta');
          if (res) res.style.maxHeight = res.scrollHeight + 'px';
        });
      }, 150);
    });
  }

  /* --- Galeria del producto -------------------------------------------- */

  function initGaleria() {
    var galeria = document.querySelector('[data-af-galeria]');
    if (!galeria) return;

    if (galeria.dataset.afGaleriaListo === '1') return;

    var principal = galeria.querySelector('[data-af-galeria-principal]');
    var minis = galeria.querySelectorAll('[data-af-galeria-mini]');
    if (!principal || !minis.length) return;

    galeria.dataset.afGaleriaListo = '1';

    var modelo = galeria.querySelector('[data-af-galeria-modelo]');
    var botonModelo = galeria.querySelector('[data-af-galeria-modelo-boton]');
    var videos = galeria.querySelectorAll('[data-af-galeria-video]');
    var botonesVideo = galeria.querySelectorAll('[data-af-galeria-video-boton]');

    // Pausa y oculta cualquier video que estuviera reproduciendose: se llama
    // antes de mostrar la foto, el modelo 3D o cualquier otro video.
    function ocultaVideos() {
      videos.forEach(function (v) {
        v.hidden = true;
        var tag = v.querySelector('[data-af-galeria-video-tag]');
        if (tag) { tag.pause(); }
      });
    }

    minis.forEach(function (mini) {
      mini.addEventListener('click', function () {
        var src = mini.dataset.afGaleriaMini;
        if (!src) return;

        // Si el visor 3D o un video estaban abiertos, se vuelve a la foto.
        if (modelo) { modelo.hidden = true; }
        ocultaVideos();
        principal.hidden = false;

        principal.style.opacity = '0';
        setTimeout(function () {
          principal.src = src;
          var alt = mini.querySelector('img');
          principal.alt = alt ? alt.alt : '';
          principal.style.opacity = '1';
        }, 180);

        minis.forEach(function (m) { m.classList.remove('af-activa'); });
        mini.classList.add('af-activa');
      });
    });

    if (modelo && botonModelo) {
      botonModelo.addEventListener('click', function () {
        principal.hidden = true;
        ocultaVideos();
        modelo.hidden = false;
        minis.forEach(function (m) { m.classList.remove('af-activa'); });
        botonModelo.classList.add('af-activa');
      });
    }

    botonesVideo.forEach(function (boton) {
      boton.addEventListener('click', function () {
        var clave = boton.dataset.afGaleriaVideoBoton;
        var caja = galeria.querySelector('[data-af-galeria-video="' + clave + '"]');
        if (!caja) return;

        principal.hidden = true;
        if (modelo) { modelo.hidden = true; }
        ocultaVideos();

        caja.hidden = false;
        var tag = caja.querySelector('[data-af-galeria-video-tag]');
        if (tag) {
          if (!reduce) {
            var intento = tag.play();
            if (intento && typeof intento.catch === 'function') intento.catch(function () {});
          }
        }

        minis.forEach(function (m) { m.classList.remove('af-activa'); });
        if (botonModelo) botonModelo.classList.remove('af-activa');
        boton.classList.add('af-activa');
      });
    });

    // El video de giro 360° arranca visible de entrada (es lo primero que
    // se ve al abrir la ficha). El atributo autoplay basta casi siempre,
    // pero por si el navegador lo bloquea se refuerza pidiendo play() a
    // mano, igual que con el video de fondo del hero.
    videos.forEach(function (v) {
      if (v.hidden || reduce) return;
      var tag = v.querySelector('[data-af-galeria-video-tag]');
      if (!tag) return;
      var intento = tag.play();
      if (intento && typeof intento.catch === 'function') intento.catch(function () {});
    });
  }

  /* --- Selector de variantes ------------------------------------------- */

  function initVariantes() {
    var raiz = document.querySelector('[data-af-producto]');
    if (!raiz) return;
    if (raiz.dataset.afVariantesListo === '1') return;
    raiz.dataset.afVariantesListo = '1';

    var datos = raiz.querySelector('[data-af-variantes-json]');
    var inputId = raiz.querySelector('[data-af-variante-id]');
    if (!datos || !inputId) return;

    var variantes;
    try {
      variantes = JSON.parse(datos.textContent);
    } catch (e) {
      return;
    }
    if (!variantes || !variantes.length) return;

    var grupos = raiz.querySelectorAll('[data-af-opcion-grupo]');
    if (!grupos.length) return;

    var precioEl = raiz.querySelector('[data-af-precio]');
    var precioAntesEl = raiz.querySelector('[data-af-precio-antes]');
    var botonEl = raiz.querySelector('[data-af-anadir]');
    var stockEl = raiz.querySelector('[data-af-stock]');
    var puntoEl = raiz.querySelector('[data-af-punto]');

    var textoAnadir = botonEl ? botonEl.dataset.afTextoAnadir || 'Añadir al carrito' : '';
    var textoAgotado = botonEl ? botonEl.dataset.afTextoAgotado || 'Agotado' : '';
    var textoDisponible = stockEl ? stockEl.dataset.afTextoDisponible || 'En stock' : '';
    var textoSinStock = stockEl ? stockEl.dataset.afTextoSinStock || 'Sin stock' : '';

    function seleccionadas() {
      var out = [];
      grupos.forEach(function (g) {
        var activa = g.querySelector('.af-variante__opcion.af-activa');
        out.push(activa ? activa.dataset.afValor : null);
      });
      return out;
    }

    function actualiza() {
      var sel = seleccionadas();

      var match = null;
      for (var i = 0; i < variantes.length; i++) {
        var v = variantes[i];
        var ok = true;
        for (var j = 0; j < sel.length; j++) {
          if (sel[j] !== null && v.options[j] !== sel[j]) { ok = false; break; }
        }
        if (ok) { match = v; break; }
      }

      if (!match) return;

      inputId.value = match.id;

      if (precioEl && match.precio_formateado) precioEl.textContent = match.precio_formateado;

      if (precioAntesEl) {
        if (match.antes_formateado) {
          precioAntesEl.textContent = match.antes_formateado;
          precioAntesEl.style.display = '';
        } else {
          precioAntesEl.style.display = 'none';
        }
      }

      if (botonEl) {
        botonEl.disabled = !match.disponible;
        botonEl.textContent = match.disponible ? textoAnadir : textoAgotado;
        botonEl.classList.toggle('af-btn--agotado', !match.disponible);
      }

      if (stockEl) stockEl.textContent = match.disponible ? textoDisponible : textoSinStock;
      if (puntoEl) puntoEl.classList.toggle('af-punto--agotado', !match.disponible);

      // refleja la variante en la URL sin recargar
      if (window.history && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', match.id);
        window.history.replaceState({}, '', url.toString());
      }
    }

    grupos.forEach(function (g) {
      g.querySelectorAll('.af-variante__opcion').forEach(function (btn) {
        btn.addEventListener('click', function () {
          g.querySelectorAll('.af-variante__opcion').forEach(function (b) {
            b.classList.remove('af-activa');
          });
          btn.classList.add('af-activa');
          actualiza();
        });
      });
    });
  }

  /* --- Comparador antes / despues --------------------------------------- */

  function initComparador() {
    var comps = document.querySelectorAll('[data-af-comparador]');

    comps.forEach(function (comp) {
      if (comp.dataset.afCompListo === '1') return;
      var rango = comp.querySelector('.af-comp__rango');
      var etAntes = comp.querySelector('.af-comp__etiqueta--antes');
      var etDespues = comp.querySelector('.af-comp__etiqueta--despues');
      var pista = comp.querySelector('[data-af-comp-pista]');
      if (!rango) return;

      function pinta() {
        var v = parseFloat(rango.value);
        if (isNaN(v)) v = 50;
        comp.style.setProperty('--af-pos', v + '%');
        // Las etiquetas se desvanecen cuando el asa las va a pisar
        if (etAntes) etAntes.style.opacity = v < 18 ? '0' : '1';
        if (etDespues) etDespues.style.opacity = v > 82 ? '0' : '1';
      }

      function ocultaPista() {
        if (!pista) return;
        pista.classList.add('af-oculta');
        pista = null;
      }

      rango.addEventListener('input', function () { pinta(); ocultaPista(); });
      rango.addEventListener('change', pinta);

      // --- Arrastre directo desde cualquier punto de la foto ---------------
      // En movil lo natural es arrastrar sobre la imagen, no buscar el asa.
      // touch-action: pan-y (en el CSS) deja el scroll vertical al navegador
      // y nos entrega a nosotros el gesto horizontal.
      var arrastrando = false;

      function valorDesdeX(clientX) {
        var caja = comp.getBoundingClientRect();
        if (!caja.width) return null;
        var p = ((clientX - caja.left) / caja.width) * 100;
        return Math.max(0, Math.min(100, p));
      }

      function mueve(e) {
        var v = valorDesdeX(e.clientX);
        if (v === null) return;
        rango.value = v;
        pinta();
        ocultaPista();
      }

      comp.addEventListener('pointerdown', function (e) {
        if (e.pointerType === 'mouse' && e.button !== 0) return;
        arrastrando = true;
        comp.classList.add('af-arrastrando');
        try { comp.setPointerCapture(e.pointerId); } catch (err) {}
        mueve(e);
      });

      comp.addEventListener('pointermove', function (e) {
        if (!arrastrando) return;
        mueve(e);
      });

      function suelta(e) {
        if (!arrastrando) return;
        arrastrando = false;
        comp.classList.remove('af-arrastrando');
        try { comp.releasePointerCapture(e.pointerId); } catch (err) {}
      }

      comp.addEventListener('pointerup', suelta);
      comp.addEventListener('pointercancel', suelta);

      // El input real se queda para teclado y lectores de pantalla
      rango.addEventListener('focus', function () { comp.classList.add('af-enfocado'); });
      rango.addEventListener('blur', function () { comp.classList.remove('af-enfocado'); });

      pinta();
      comp.dataset.afCompListo = '1';
    });

    // --- Pestañas para cambiar de escena ---------------------------------
    document.querySelectorAll('[data-af-comp-bloque]').forEach(function (bloque) {
      if (bloque.dataset.afTabsListo === '1') return;
      var tabs = bloque.querySelectorAll('[data-af-comp-tab]');
      var paneles = bloque.querySelectorAll('[data-af-comp-panel]');
      if (!tabs.length) return;

      function activa(indice) {
        tabs.forEach(function (t) {
          var suyo = t.dataset.afCompTab === indice;
          t.classList.toggle('af-activa', suyo);
          t.setAttribute('aria-selected', suyo ? 'true' : 'false');
          t.tabIndex = suyo ? 0 : -1;
        });
        paneles.forEach(function (p) {
          p.classList.toggle('af-oculto', p.dataset.afCompPanel !== indice);
        });
      }

      tabs.forEach(function (tab, i) {
        tab.addEventListener('click', function () { activa(tab.dataset.afCompTab); });

        // Flechas izquierda/derecha entre pestañas, como manda la accesibilidad
        tab.addEventListener('keydown', function (e) {
          var salto = e.key === 'ArrowRight' ? 1 : (e.key === 'ArrowLeft' ? -1 : 0);
          if (!salto) return;
          e.preventDefault();
          var siguiente = tabs[(i + salto + tabs.length) % tabs.length];
          activa(siguiente.dataset.afCompTab);
          siguiente.focus();
        });
      });

      bloque.dataset.afTabsListo = '1';
    });
  }

  /* --- Cantidad --------------------------------------------------------- */

  function initCantidad() {
    document.querySelectorAll('[data-af-cantidad]').forEach(function (caja) {
      // Sin esta guarda, cada ejecucion repetida de af-scripts.js sobre el
      // mismo boton sumaba un clic mas: pulsar "+" una vez podia sumar
      // varias unidades de golpe.
      if (caja.dataset.afCantidadListo === '1') return;
      var input = caja.querySelector('input');
      var menos = caja.querySelector('[data-af-menos]');
      var mas = caja.querySelector('[data-af-mas]');
      if (!input) return;
      caja.dataset.afCantidadListo = '1';

      if (menos) menos.addEventListener('click', function () {
        var v = parseInt(input.value, 10) || 1;
        if (v > 1) input.value = v - 1;
      });

      if (mas) mas.addEventListener('click', function () {
        var v = parseInt(input.value, 10) || 1;
        input.value = v + 1;
      });
    });
  }

  /* --- Aviso a Meta al añadir al carrito -------------------------------- */
  // El formulario de compra es un envio normal (recarga la pagina y va a
  // /cart), no una llamada AJAX. Por eso no interceptamos el envio: nos
  // limitamos a disparar el aviso justo antes de que el navegador navegue,
  // usando el precio y la variante que ya estan pintados en la pagina.
  // Los navegadores completan este tipo de aviso (usa sendBeacon/imagen)
  // aunque la pagina cambie justo despues.

  function initMetaAddToCart() {
    if (typeof window.fbq !== 'function') return;
    var form = document.getElementById('af-form-producto');
    if (!form || form.dataset.afMetaListo === '1') return;
    form.dataset.afMetaListo = '1';

    form.addEventListener('submit', function () {
      var raiz = form.closest('[data-af-producto]');
      var idInput = form.querySelector('[data-af-variante-id]');
      var precioEl = raiz ? raiz.querySelector('[data-af-precio]') : null;
      var cantidadInput = form.querySelector('input[name="quantity"]');

      var precioUnidad = precioEl ? parseFloat(precioEl.textContent.replace(/[^0-9.,]/g, '').replace(',', '.')) : 0;
      var cantidad = cantidadInput ? parseInt(cantidadInput.value, 10) || 1 : 1;

      window.fbq('track', 'AddToCart', {
        content_ids: idInput ? [idInput.value] : [],
        content_type: 'product',
        value: Math.round(precioUnidad * cantidad * 100) / 100,
        currency: (raiz && raiz.dataset.afMoneda) || 'USD'
      });
    });
  }

  /* --- Inclinacion 3D al pasar el cursor --------------------------------- */
  // Solo en pantallas con raton de verdad: en movil el dedo no "sobrevuela"
  // nada, asi que no tiene sentido (y podria dar tirones raros al tocar).

  function initTilt() {
    if (reduce) return;
    if (!window.matchMedia || !window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;

    document.querySelectorAll('[data-af-tilt]').forEach(function (el) {
      if (el.dataset.afTiltListo === '1') return;
      el.dataset.afTiltListo = '1';

      var maxGrados = parseFloat(el.dataset.afTilt) || 6;

      el.addEventListener('mousemove', function (e) {
        var r = el.getBoundingClientRect();
        var px = (e.clientX - r.left) / r.width;
        var py = (e.clientY - r.top) / r.height;
        var rx = (0.5 - py) * maxGrados * 2;
        var ry = (px - 0.5) * maxGrados * 2;
        el.style.transform = 'perspective(900px) rotateX(' + rx.toFixed(2) + 'deg) rotateY(' + ry.toFixed(2) + 'deg) scale3d(1.02, 1.02, 1.02)';
      });

      el.addEventListener('mouseleave', function () {
        el.style.transform = '';
      });
    });
  }

  /* --- Barra flotante de compra ------------------------------------------ */
  // Se muestra cuando el boton real de "Añadir al carrito" ya quedo por
  // encima de la pantalla (el visitante siguio bajando). Su boton no repite
  // la logica de compra: dispara el envio del formulario real, asi que
  // hereda el mismo aviso a Meta que ya tiene ese formulario.

  function initBarraFlotante() {
    var barra = document.querySelector('[data-af-barra-flotante]');
    var form = document.getElementById('af-form-producto');
    if (!barra || !form || barra.dataset.afBarraListo === '1') return;
    barra.dataset.afBarraListo = '1';

    var raiz = form.closest('[data-af-producto]');
    var botonReal = form.querySelector('[data-af-anadir]');
    var precioReal = raiz ? raiz.querySelector('[data-af-precio]') : null;
    var precioBarra = barra.querySelector('[data-af-barra-precio]');
    var botonBarra = barra.querySelector('[data-af-barra-boton]');
    if (!botonReal) return;

    // Mantiene el precio y el estado (agotado/disponible) de la barra
    // sincronizados con los reales cuando alguien cambia de version.
    if ('MutationObserver' in window) {
      if (precioReal && precioBarra) {
        new MutationObserver(function () {
          precioBarra.textContent = precioReal.textContent;
        }).observe(precioReal, { childList: true, characterData: true, subtree: true });
      }
      if (botonBarra) {
        new MutationObserver(function () {
          botonBarra.disabled = botonReal.disabled;
          botonBarra.textContent = botonReal.textContent.trim();
        }).observe(botonReal, { attributes: true, attributeFilter: ['disabled'], childList: true, characterData: true, subtree: true });
      }
    }

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        var entry = entries[0];
        var yaPaso = entry.boundingClientRect.top < 0 && !entry.isIntersecting;
        barra.classList.toggle('af-visible', yaPaso);
        barra.setAttribute('aria-hidden', yaPaso ? 'false' : 'true');
      }, { threshold: 0 }).observe(botonReal);
    }

    if (botonBarra) {
      botonBarra.addEventListener('click', function () {
        if (form.requestSubmit) form.requestSubmit();
        else form.submit();
      });
    }
  }

  /* --- Arranque --------------------------------------------------------- */

  /* --- Carrusel de productos del hero ------------------------------------- */
  // Cada N segundos la pista se desplaza una diapositiva a la izquierda. Se
  // clona la primera al final para que el salto de la ultima a la primera
  // siga el mismo movimiento; al llegar al clon se vuelve a 0 sin animacion.

  function initHeroSlides() {
    var cont = document.querySelector('[data-af-hero-slides]');
    if (!cont || cont.dataset.afListo === '1') return;
    var pista = cont.querySelector('[data-af-hero-pista]');
    if (!pista) return;
    var originales = pista.children;
    var n = originales.length;
    if (n < 2) return;
    cont.dataset.afListo = '1';

    var clon = originales[0].cloneNode(true);
    clon.setAttribute('aria-hidden', 'true');
    clon.setAttribute('tabindex', '-1');
    pista.appendChild(clon);

    // Los videos del carrusel arrancan a mano (autoplay a veces se bloquea).
    pista.querySelectorAll('video').forEach(function (v) {
      if (reduce) return;
      var intento = v.play();
      if (intento && typeof intento.catch === 'function') intento.catch(function () {});
    });

    var puntos = cont.querySelectorAll('[data-af-hero-punto]');
    var intervalo = (parseInt(cont.dataset.afIntervalo, 10) || 3) * 1000;
    var idx = 0;
    var timer = null;

    function mover(i, anima) {
      pista.style.transition = anima ? 'transform 0.9s cubic-bezier(0.22, 1, 0.36, 1)' : 'none';
      pista.style.transform = 'translateX(' + (-i * 100) + '%)';
    }

    function marca(i) {
      puntos.forEach(function (p, k) { p.classList.toggle('af-activa', k === i % n); });
    }

    function siguiente() {
      idx += 1;
      mover(idx, true);
      marca(idx);
      if (idx === n) {
        setTimeout(function () {
          // el clon del video va por su cuenta: se sincroniza antes de saltar
          var v0 = originales[0].querySelector('video');
          var vc = clon.querySelector('video');
          if (v0 && vc) { try { v0.currentTime = vc.currentTime; } catch (e) {} }
          idx = 0;
          mover(0, false);
        }, 950);
      }
    }

    function parar() { if (timer) { clearInterval(timer); timer = null; } }
    function arrancar() {
      parar();
      if (reduce) return;
      timer = setInterval(siguiente, intervalo);
    }

    puntos.forEach(function (p, k) {
      p.addEventListener('click', function () {
        idx = k;
        mover(k, true);
        marca(k);
        arrancar();
      });
    });

    // En pantallas tactiles mouseenter se dispara al tocar y nunca se "suelta".
    if (window.matchMedia && window.matchMedia('(hover: hover)').matches) {
      cont.addEventListener('mouseenter', parar);
      cont.addEventListener('mouseleave', arrancar);
    }
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) parar(); else arrancar();
    });

    arrancar();
  }

  function arranca() {
    initVideoHero();
    initHeroSlides();
    initReveals();
    initCifras();
    initFaq();
    initGaleria();
    initVariantes();
    initComparador();
    initCantidad();
    initMetaAddToCart();
    initTilt();
    initBarraFlotante();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', arranca);
  } else {
    arranca();
  }

  // el editor de Shopify recarga secciones sueltas
  document.addEventListener('shopify:section:load', arranca);
})();
